import { render } from "./ReviewingCount.vue?vue&type=template&id=376d402b"
import script from "./ReviewingCount.vue?vue&type=script&lang=js"
export * from "./ReviewingCount.vue?vue&type=script&lang=js"

import "./ReviewingCount.vue?vue&type=style&index=0&id=376d402b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pullrequests/ReviewingCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "376d402b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('376d402b', __exports__)) {
    api.reload('376d402b', __exports__)
  }
  
  module.hot.accept("./ReviewingCount.vue?vue&type=template&id=376d402b", () => {
    api.rerender('376d402b', render)
  })

}


export default __exports__